module.exports = __webpack_public_path__ + "static/media/20ECE9.ae1298d4.jpg";